module.exports = __webpack_public_path__ + "img/c-cabriolet.45c8ace9.png";